import { render } from "./LeavePotsUntouched.vue?vue&type=template&id=dd7655ea&ts=true"
import script from "./LeavePotsUntouched.vue?vue&type=script&lang=ts"
export * from "./LeavePotsUntouched.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__